import { DBConfig } from "ngx-indexed-db";

const storeNameProducts = "products";
const storeNameProjects = "projects";
const storeNameMetadata = "metadata";
const storeNameGases = "gases";
const storeNameLastProductUpdate = "lastProductUpdate";
const storeNameMonitoringPatientMonitorDevices = "monitoringPatientMonitorDevices";
const storeNameMonitoringPatientMonitorFamilies = "monitoringPatientMonitorFamilies";
const storeNameMonitoringCentralStationDevices = "monitoringCentralStationDevices";
const storeNameMonitoringCentralStationFamilies = "monitoringCentralStationFamilies";
const storeNameMonitoringTelemetryDevices = "monitoringTelemetryDevices";
const storeNameMonitoringTelemetryFamilies = "monitoringTelemetryFamilies";
const storeNameMonitoringKvmDevices = "monitoringKvmDevices";
const storeNameMonitoringKvmFamilies = "monitoringKvmFamilies";
const storeNameMonitoringDisplayDevices = "monitoringDisplayDevices";
const storeNameMonitoringDisplayFamilies = "monitoringDisplayFamilies";
const storeNameMonitoringUtilityDevices = "monitoringUtilityDevices";
const storeNameMonitoringUtilityFamilies = "monitoringUtilityFamilies";
const storeNameProjectImages = "projectImages";
const storeNameProjectFloorplans = "projectFloorplans";

export const INDEXED_DB_CONFIG: DBConfig = {
  name: "Navinta",
  version: 7,
  objectStoresMeta: [
    {
      store: storeNameProducts,
      storeConfig: { keyPath: "id", autoIncrement: false },
      storeSchema: [{ name: "name", keypath: "name", options: { unique: false } }],
    },
    {
      store: storeNameProjects,
      storeConfig: { keyPath: "id", autoIncrement: false },
      storeSchema: [{ name: "name", keypath: "name", options: { unique: false } }],
    },
    {
      store: storeNameMetadata,
      storeConfig: { keyPath: "id", autoIncrement: false },
      storeSchema: [],
    },
    {
      store: storeNameGases,
      storeConfig: { keyPath: "id", autoIncrement: false },
      storeSchema: [],
    },
    {
      store: storeNameLastProductUpdate,
      storeConfig: { keyPath: "id", autoIncrement: false },
      storeSchema: [],
    },
    {
      store: storeNameMonitoringPatientMonitorDevices,
      storeConfig: { keyPath: "matNr", autoIncrement: false },
      storeSchema: [],
    },
    {
      store: storeNameMonitoringPatientMonitorFamilies,
      storeConfig: { keyPath: "familyNumber", autoIncrement: false },
      storeSchema: [],
    },
    {
      store: storeNameMonitoringCentralStationDevices,
      storeConfig: { keyPath: "matNr", autoIncrement: false },
      storeSchema: [],
    },
    {
      store: storeNameMonitoringCentralStationFamilies,
      storeConfig: { keyPath: "familyNumber", autoIncrement: false },
      storeSchema: [],
    },
    {
      store: storeNameMonitoringTelemetryDevices,
      storeConfig: { keyPath: "matNr", autoIncrement: false },
      storeSchema: [],
    },
    {
      store: storeNameMonitoringTelemetryFamilies,
      storeConfig: { keyPath: "familyNumber", autoIncrement: false },
      storeSchema: [],
    },
    {
      store: storeNameMonitoringKvmDevices,
      storeConfig: { keyPath: "matNr", autoIncrement: false },
      storeSchema: [],
    },
    {
      store: storeNameMonitoringKvmFamilies,
      storeConfig: { keyPath: "familyNumber", autoIncrement: false },
      storeSchema: [],
    },
    {
      store: storeNameMonitoringDisplayDevices,
      storeConfig: { keyPath: "matNr", autoIncrement: false },
      storeSchema: [],
    },
    {
      store: storeNameMonitoringDisplayFamilies,
      storeConfig: { keyPath: "familyNumber", autoIncrement: false },
      storeSchema: [],
    },
    {
      store: storeNameMonitoringUtilityDevices,
      storeConfig: { keyPath: "matNr", autoIncrement: false },
      storeSchema: [],
    },
    {
      store: storeNameMonitoringUtilityFamilies,
      storeConfig: { keyPath: "familyNumber", autoIncrement: false },
      storeSchema: [],
    },
    {
      store: storeNameProjectImages,
      storeConfig: { keyPath: "id", autoIncrement: false },
      storeSchema: [
        { name: "projectId", keypath: "imageMetadata.projectId", options: { unique: false } },
        { name: "synced", keypath: "synced", options: { unique: false } },
      ],
    },
    {
      store: storeNameProjectFloorplans,
      storeConfig: { keyPath: "id", autoIncrement: false },
      storeSchema: [],
    },
  ],
};

export const STORE_NAME_PRODUCTS = storeNameProducts;
export const STORE_NAME_PROJECTS = storeNameProjects;
export const STORE_NAME_METADATA = storeNameMetadata;
export const STORE_NAME_GASES = storeNameGases;
export const STORE_NAME_LAST_PRODUCT_UPDATE = storeNameLastProductUpdate;
export const STORE_NAME_MONITORING_PATIENT_MONITOR_DEVICES = storeNameMonitoringPatientMonitorDevices;
export const STORE_NAME_MONITORING_PATIENT_MONITOR_FAMILIES = storeNameMonitoringPatientMonitorFamilies;
export const STORE_NAME_MONITORING_CENTRAL_STATION_DEVICES = storeNameMonitoringCentralStationDevices;
export const STORE_NAME_MONITORING_CENTRAL_STATION_FAMILIES = storeNameMonitoringCentralStationFamilies;
export const STORE_NAME_MONITORING_TELEMETRY_DEVICES = storeNameMonitoringTelemetryDevices;
export const STORE_NAME_MONITORING_TELEMETRY_FAMILIES = storeNameMonitoringTelemetryFamilies;
export const STORE_NAME_MONITORING_KVM_DEVICES = storeNameMonitoringKvmDevices;
export const STORE_NAME_MONITORING_KVM_FAMILIES = storeNameMonitoringKvmFamilies;
export const STORE_NAME_MONITORING_DISPLAY_DEVICES = storeNameMonitoringDisplayDevices;
export const STORE_NAME_MONITORING_DISPLAY_FAMILIES = storeNameMonitoringDisplayFamilies;
export const STORE_NAME_MONITORING_UTILITY_DEVICES = storeNameMonitoringUtilityDevices;
export const STORE_NAME_MONITORING_UTILITY_FAMILIES = storeNameMonitoringUtilityFamilies;
export const STORE_NAME_PROJECT_IMAGES = storeNameProjectImages;
export const STORE_NAME_PROJECT_FLOORPLANS = storeNameProjectFloorplans;
